import { Box, Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import WTypography from 'Components/whiteTypography'

// État vide réutilisable pour les cartes du tableau de bord Mon Patrimoine.
// Affiché lorsqu'une carte n'a aucune donnée : icône, message d'explication
// et un appel à l'action clair pour démarrer (créer un budget, un objectif…).
function EmptyCardState({ icon, title, description, ctaLabel, onCta }) {
  return (
    <Box
      className="no-drag"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        flexGrow: 1,
        minHeight: 240,
        py: 4,
        px: 2,
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'rgba(255,255,255,0.08)',
          color: '#7ab1df',
          mb: 2,
          '& svg': { fontSize: 32 },
        }}
      >
        {icon}
      </Box>

      <WTypography variant="h6" sx={{ color: '#ffffff', fontWeight: 800, mb: 0.75 }}>
        {title}
      </WTypography>

      <WTypography
        variant="body2"
        sx={{ color: '#ffffffa1', mb: 2.5, maxWidth: 300, lineHeight: 1.5 }}
      >
        {description}
      </WTypography>

      <Button
        variant="contained"
        onClick={onCta}
        startIcon={<AddIcon />}
        sx={{
          bgcolor: '#1c86e9',
          color: '#fff',
          textTransform: 'none',
          fontWeight: 700,
          borderRadius: 2,
          px: 2.5,
          boxShadow: 'none',
          '&:hover': { bgcolor: '#1263af', boxShadow: 'none' },
        }}
      >
        {ctaLabel}
      </Button>
    </Box>
  )
}

export default EmptyCardState
